import { render, staticRenderFns } from "./SignatureComponent.vue?vue&type=template&id=1b749e04&"
import script from "./SignatureComponent.vue?vue&type=script&lang=js&"
export * from "./SignatureComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports